export default __webpack_public_path__ + "static/media/wl_about.493c50a5.jpg";